import { Theme } from '../Types/types';

export async function authenticate(username: string, password: string, setTheme: (theme: Theme) => void) {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL + `login`, {
      method: 'POST',
      headers: new Headers({
        // Your header content
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ username, password: password }),
    });
    if (response.ok) {
      const data = await response.json();
      localStorage.setItem('accesstoken', data.accesstoken);
      localStorage.setItem('refreshtoken', data.refreshtoken);
      localStorage.setItem('name', data.name);

      if (data.clientId === '15') {
        localStorage.setItem('clientid', data.clientId);
      }

      if (data.theme !== undefined) {
        localStorage.setItem('theme', data.theme);
        setTheme(data.theme);
      }

      return { success: true, error: undefined };
    } else {
      console.error('Authentication failed', response.status);
      return { success: false, error: 'Authentication failed' };
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return { success: false, error: 'Internal server error' };
  }
}

export function logout() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/login';
}
